/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import AppUtils from '../../../../utilities/AppUtils';

import InputWithLabel from '../../../components/InputWithLabel';
import Card, { CardSection } from '../../../components/card/Card';
import { ConnectedGrayPrivacyCard } from '../../../components/card/PrivacyCard';
import { PolicyName } from '../../../../models/PolicyModel';
import { ScrollAwareScroller } from '../../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../../components/appNav/AppHeaderScrollable';
import ContentWrapper from '../../../components/ContentWrapper';

class ProfileName extends React.Component {

  constructor(props) {
    super(props);

    this.handleGivenNamesChange = this.handleGivenNamesChange.bind(this);
    this.handleFamilyNamesChange = this.handleFamilyNamesChange.bind(this);
    this.handlePreferredNameChange = this.handlePreferredNameChange.bind(this);
    this.updatePreferredName = this.updatePreferredName.bind(this);
  }

  nameCapitalize(string) {
    if (AppUtils.isNotSupportAutoCap()) {
      const name = string.split(/\s+/g);
      const autoCapitalize = name.map(e => (e !== '' ? e[0].toUpperCase() + e.substr(1, e.length) : ''));
      return autoCapitalize.join(' ');
    }
    return string;
  }

  handleGivenNamesChange(event) {
    const givenName = this.nameCapitalize(event.target.value);
    const newProfileData = _.assign({}, this.props.profileData, {
      given_names: givenName,
    });
    this.props.onChange(newProfileData);
  }

  handleFamilyNamesChange(event) {
    const familyName = this.nameCapitalize(event.target.value);
    const newProfileData = _.assign({}, this.props.profileData, {
      family_names: familyName,
    });
    this.props.onChange(newProfileData);
  }

  handlePreferredNameChange(event) {
    const preferredName = this.nameCapitalize(event.target.value);
    const newProfileData = _.assign({}, this.props.profileData, {
      preferred_name: preferredName,
    });
    this.props.onChange(newProfileData);
  }

  updatePreferredName(event) {
    if (_.isEmpty(this.props.profileData.preferred_name)) {
      const firstWord = event.target.value.split(' ')[0];
      const newProfileData = _.assign({}, this.props.profileData, {
        preferred_name: firstWord,
      });
      this.props.onChange(newProfileData);
    }
  }

  render() {
    const givenName = this.props.profileData.given_names || '';
    const familyName = this.props.profileData.family_names || '';
    const preferredName = this.props.profileData.preferred_name || '';

    return (
      <ScrollAwareScroller>
        <AppHeaderScrollableText {...this.props.title} />

        <ContentWrapper>

          <ConnectedGrayPrivacyCard
            name={PolicyName.NAME}
            subTitle="privacy.privacyBlock.name.teaser"
            onWithdrawConsent={this.props.onWithdrawConsent}
          />

          <Card>
            <form onSubmit={this.props.submitForm}>
              <CardSection hasBorder>
                <InputWithLabel
                  value={givenName}
                  onChange={this.handleGivenNamesChange}
                  onFocus={this.props.clearViewErrors}
                  onBlur={this.updatePreferredName}
                  autoCapitalize="words"
                  type="text"
                  label={<FormattedMessage id={this.props.phraseData.givenNameFieldLabel.id} />}
                  name="given_names"
                  initialFocus={false}
                />
              </CardSection>

              <CardSection hasBorder>
                <InputWithLabel
                  value={familyName}
                  onChange={this.handleFamilyNamesChange}
                  onFocus={this.props.clearViewErrors}
                  onBlur={this.updatePreferredName}
                  autoCapitalize="words"
                  type="text"
                  label={<FormattedMessage id={this.props.phraseData.familyNameFieldLabel.id} />}
                  name="family_names"
                />
              </CardSection>

              <CardSection>
                <InputWithLabel
                  value={preferredName}
                  onChange={this.handlePreferredNameChange}
                  onFocus={this.props.clearFieldErrors}
                  autoCapitalize="words"
                  type="text"
                  label={<FormattedMessage id={this.props.phraseData.preferredNameFieldLabel.id} />}
                  name="preferred_name"
                  isInvalid={false}
                />
              </CardSection>

              <input type="submit" style={{ visibility: 'hidden', display: 'none' }} />
            </form>
          </Card>

        </ContentWrapper>
      </ScrollAwareScroller>
    );
  }
}
ProfileName.propTypes = {
  title: PropTypes.object,
  phraseData: PropTypes.object,
  profileData: PropTypes.object.isRequired,
  submitForm: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  clearViewErrors: PropTypes.func.isRequired,
  clearFieldErrors: PropTypes.func.isRequired,
  submitErrorText: PropTypes.any,
  fieldErrorName: PropTypes.string,
  onWithdrawConsent: PropTypes.func,
};

export default ProfileName;
